import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { NotificationManager } from "react-notifications";

import { FormField } from "../../../../sharedComponents/formField";
import { required } from "../../../../constants/formValidators";

const AddMeasureForm = ({ initialValues, handleSubmit, onAdd, onUpdate, togglePanel, resetForm, form }) => {
	const validateForm = (values) => {
		if (initialValues) {
			initialValues !== values ? onUpdate(values) : NotificationManager.warning("Nothing to update!", "", 5000);
		} else {
			resetForm(form);
			onAdd(values);
			togglePanel()
		}
	};

	return (
		<form onSubmit={handleSubmit(validateForm)} className="flex-fill d-flex flex-column w-100">
			<div className="flex-fill">
				<h4 className="title-primary-dark mb-4">Add weight and measure</h4>
				<h5>Sequence: Determines order measures will be displayed</h5>
				<h5>Measure: type of measurement, cup, oz, etc.</h5>
				<h5>Quantity: # of measures e.g. 5 cups</h5>
				<h5>Grams: e.g. grams in 5 cups (OPTIONAL)</h5>
				<Field label="Sequence" name="sequence" type="number" component={FormField} validate={[required]} />
				<Field label="Measure" name="measure" type="text" component={FormField} validate={[required]} />
				<Field label="Quantity" name="quantity" type="number" component={FormField} validate={[required]} min="0.01" step="0.01" />
				<Field label="Grams" name="grams" type="number" component={FormField} validate={[]} min="0.01" step="0.01" />
			</div>
			<div className="d-flex align-items-end justify-content-end">
				<button className="btn btn-primary-dark" type="submit">
					{initialValues ? "Submit" : "Add item"}
				</button>
			</div>
		</form>
	);
};

const mapDispatchToProps = {
	resetForm: reset
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "AddMeasureForm",
		enableReinitialize: true
	})(AddMeasureForm)
);
